/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "sortby"
})
export class SortByPipe implements PipeTransform {
  transform(array: Array<any>, args: any): Array<any> {
    const field = args.field, fieldLength = field.split(".");
    const direction = args.isDesc ? 1 : -1;
    if (array) {
      if (fieldLength.length > 1) {
        array.sort((a: any, b: any) => {
          if (a[fieldLength[0]][fieldLength[1]] < b[fieldLength[0]][fieldLength[1]]) {
            return -1 * direction;
          } else if (a[fieldLength[0]][fieldLength[1]] > b[fieldLength[0]][fieldLength[1]]) {
            return 1 * direction;
          } else {
            return 0;
          }
        });
      } else {
        array.sort((a, b) => {
          if (isNaN(a[field]) || isNaN(b[field])) {
           return a[field] > b[field] ? 1 * direction : -1 * direction;
          }
          return direction == 1 ? b[field]-a[field] : a[field]-b[field];          
        });
      }
    }
    return array;
  }
}